/* eslint-disable max-classes-per-file */
export class NotFound extends Error {
  constructor(msg) {
    super(msg);
    Object.setPrototypeOf(this, Error.prototype);
    this.name = msg;
    if (Error.captureStackTrace) Error.captureStackTrace(this, NotFound);
  }
}

export class GTMError extends Error {
  constructor(msg) {
    super(msg);
    Object.setPrototypeOf(this, GTMError.prototype);
    this.name = 'GTMError';
    if (Error.captureStackTrace) Error.captureStackTrace(this, GTMError);
  }
}

export class QuotaExceededError extends Error {
  constructor(msg) {
    super(msg);
    Object.setPrototypeOf(this, QuotaExceededError.prototype);
    this.name = 'QuotaExceededError';
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, QuotaExceededError);
  }
}

export class FreshBotInitializationError extends Error {
  constructor(msg) {
    super(msg);
    Object.setPrototypeOf(this, FreshBotInitializationError.prototype);
    this.name = 'FreshBotInitializationError';
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, FreshBotInitializationError);
  }
}
